import { useEffect } from 'react'

const useGlobalDocumentEvent = <K extends keyof DocumentEventMap>(eventName: K, handler: (event: DocumentEventMap[K]) => void) => {
    useEffect(() => {
        document.addEventListener(eventName, handler)

        return () => {
            document.removeEventListener(eventName, handler)
        }
    }, [eventName, handler])
}

export const useGlobalKeydownEvent = (handler: (event: KeyboardEvent) => void) => {
    useGlobalDocumentEvent('keydown', handler)
}
